require('../../../common/directives/jv.pagination.directive');
require('../../../common/directives/jv.root-modal.directive.js');

angular.module('jv.Admin.Users.Roles.List.Controller', [
    'jv.common.pagination.directive',
    'jv.common.root-modal.directive'
  ])
  .controller('jvAdminUsersRolesListController', ['$scope', '$route', '$rootScope', 'jvAdminUsersRolesService', '$filter', '$location', 'jvAdminUsersRoleModalFactory', 'jvAdminUsersPermissionFactory',
    function($scope, $route, $rootScope, jvAdminUsersRolesService, $filter, $location, jvAdminUsersRoleModalFactory, jvAdminUsersPermissionFactory) {

    jvAdminUsersPermissionFactory.setPermissions();

    $scope.breadcrumbsConfig = $route.current.locals.breadcrumbsResolve;
    $scope.modalService = jvAdminUsersRoleModalFactory;

    $scope.viewPermissions = jvAdminUsersPermissionFactory;
    
    var statusFilters = [{
        "value": "Active",
        "key": true
    }, {
        "value": "Inactive",
        "key": false
    }];

    var columns = [{
        "fieldName": i18n['NAME'],
        "fieldId": "labelLowerCase",
        "canSort": true
    }, {
        "fieldName": i18n['ROLE_TYPE'],
        "fieldId": "type",
        "canSort": false
    }, {
        "fieldName": i18n['STATUS'],
        "fieldId": "status",
        "canSort": false
    }, {
        "fieldName": i18n['UPDATED'],
        "fieldId": "updateDate",
        "canSort": true
    }];

    var state = $scope.state = {
        statusFilters: statusFilters,
        columns: columns,
        firstPageLoad: true,
        queryData: {
          page: 0,
          active: true,
          sortBy: ["labelLowerCase"],
          order: "asc",
          roleTypes: ""
        },
    };
    
    getRoles();

    $scope.sortClass = function(field, classPrefix) {
        var sortBy = state.queryData.sortBy;
        if (sortBy && sortBy[0] && sortBy[0] === field) {
            return classPrefix + state.queryData.order;
        }
    };

    $scope.sort = function(fieldId) {
        var sortBy = state.queryData.sortBy;
        if (sortBy && sortBy[0] && sortBy[0] === fieldId) {
            state.queryData.order = (state.queryData.order === 'asc') ? 'desc' : 'asc';
        }
        else {
            state.queryData.sortBy = [fieldId];
            state.queryData.order = 'asc';
        }
        getRoles();
    };

    function getRoles() {
        $scope.flags.loading = true;
        return jvAdminUsersRolesService.getRoles(state.queryData, function(data) {
            state.roles = data.roles;
            state.total = data.count;
            state.pageSize = data.pageCount;
            $scope.flags.loading = false;
            state.firstPageLoad = false;
        }, function() {
          $scope.$root.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
          $scope.flags.loading = false;
          state.firstPageLoad = false;
        });
    };

    $scope.search = function() {
      state.queryData.page = 0;
      getRoles();
    };

    $scope.next = function() {
        state.queryData.page = state.queryData.page + 1;
        getRoles();
    };

    $scope.previous = function() {
        state.queryData.page = state.queryData.page - 1;
        getRoles();
    };
  }]);
